import { addHours, endOfDay, startOfDay } from "date-fns";

const SERVER_HOURS_AHEAD = 3;

/**
 * Converte um período escolhido pelo usuário no intervalo esperado pela API.
 *
 * Os seletores de data devolvem sempre 00:00 do dia escolhido, então as pontas
 * são primeiro fechadas nas bordas do dia — senão o último dia do período fica
 * de fora da busca — e só depois deslocadas para o fuso do servidor, que
 * trabalha 3h à frente do local.
 */
export function serverDateRange(start: Date, end: Date) {
  return {
    start: addHours(startOfDay(start), SERVER_HOURS_AHEAD),
    end: addHours(endOfDay(end), SERVER_HOURS_AHEAD),
  };
}
